if (typeof jQuery === "undefined") {
  throw new Error("Requires jQuery");
}

$.nuvaApp = {};

/* --------------------
 * - nuvaApp Options -
 * --------------------
 * Modify these options to suit your implementation
 */
$.nuvaApp.options = {
  //Add slimscroll to navbar menus
  //This requires you to load the slimscroll plugin
  //in every page before app.js
  navbarMenuSlimscroll: true,
  navbarMenuSlimscrollWidth: "3px", //The width of the scroll bar
  navbarMenuHeight: "200px", //The height of the inner menu
  //General animation speed for JS animated elements such as box collapse/expand and
  //sidebar treeview slide up/down. This options accepts an integer as milliseconds,
  //'fast', 'normal', or 'slow'
  animationSpeed: 150,
  //Sidebar push menu toggle button selector
  sidebarToggleSelector: "[data-toggle='offcanvas']",
  //Activate sidebar push menu
  sidebarPushMenu: true,
  //Activate sidebar slimscroll if the fixed layout is set (requires SlimScroll Plugin)
  sidebarSlimScroll: true,
  //Enable sidebar expand on hover effect for sidebar mini
  //This option is forced to true if both the fixed layout and sidebar mini
  //are used together
  sidebarExpandOnHover: true,
  //BoxRefresh Plugin
  enableBoxRefresh: true,
  //Bootstrap.js tooltip
  //enableBSToppltip: true,
  //BSTooltipSelector: "[data-toggle='tooltip']",
  //Enable Fast Click. Fastclick.js creates a more
  //native touch experience with touch devices. If you
  //choose to enable the plugin, make sure you load the script
  //before nuvaApp's app.js
  enableFastclick: false,
  //Control Sidebar Tree views
  enableControlTreeView: true,
  //Control Sidebar Options
  enableControlSidebar: true,
  controlSidebarOptions: {
    //Which button should trigger the open/close event
    toggleBtnSelector: "[data-toggle='control-sidebar']",
    //The sidebar selector
    selector: ".control-sidebar",
    //Enable slide over content
    slide: true
  },
  //Box Widget Plugin. Enable this plugin
  //to allow boxes to be collapsed and/or removed
  enableBoxWidget: true,
  //Box Widget plugin options
  boxWidgetOptions: {
    boxWidgetIcons: {
      //Collapse icon
      collapse: 'fa-minus',
      //Open icon
      open: 'fa-plus',
      //Remove icon
      remove: 'fa-times'
    },
    boxWidgetSelectors: {
      //Remove button selector
      remove: '[data-widget="remove"]',
      //Collapse button selector
      collapse: '[data-widget="collapse"]'
    }
  },
  //Direct Chat plugin options
  directChat: {
    //Enable direct chat by default
    enable: true,
    //The button to open and close the chat contacts pane
    contactToggleSelector: '[data-widget="chat-pane-toggle"]'
  },
  //Define the set of colors to use globally around the website
  colors: {
    lightBlue: "#3c8dbc",
    red: "#f56954",
    green: "#00a65a",
    aqua: "#00c0ef",
    yellow: "#f39c12",
    blue: "#0073b7",
    navy: "#001F3F",
    teal: "#39CCCC",
    olive: "#3D9970",
    lime: "#01FF70",
    orange: "#FF851B",
    fuchsia: "#F012BE",
    purple: "#8E24AA",
    maroon: "#D81B60",
    black: "#222222",
    gray: "#d2d6de"
  },
  //The standard screen sizes that bootstrap uses.
  //If you change these in the variables.less file, change
  //them here too.
  screenSizes: {
    xs: 480,
    sm: 768,
    md: 992,
    lg: 1200
  }
};

/**
 * Touch ripple helper.
 * To enable ripple on a control, you can either:
 * 1. Add a child `<span class="touch-ripple"></span>` inside it, OR
 * 2. Add `data-ripple-init` attribute to the element (the template will be created automatically)
 * The span acts as a template; the helper clones it for each interaction.
 */
(function() {
  const RIPPLE_TEMPLATE_SELECTOR = '.touch-ripple';
  const RIPPLE_INIT_ATTR = 'data-ripple-init';
  const RIPPLE_CONTAINER_CLASS = 'nt-ripple-container';
  const CONTAINER_FLAG = 'data-ripple-ready';
  const TEMPLATE_FLAG = 'data-ripple-template';
  const RIPPLE_WRAPPER_CLASS = 'ripple--container';

  const isKeyboardTrigger = (event) => {
    if (event.type !== 'keydown') return false;
    return event.key === 'Enter' || event.key === ' ';
  };

  const debounce = (func, delay) => {
    let inDebounce;
    return function() {
      const context = this;
      const args = arguments;
      clearTimeout(inDebounce);
      inDebounce = setTimeout(() => {
        func.apply(context, args);
      }, delay);
    };
  };

  const getTemplate = (container) => {
    if (!container) return null;
    return container.querySelector(`${RIPPLE_TEMPLATE_SELECTOR}[${TEMPLATE_FLAG}="true"]`);
  };

  const getRippleContainer = (element) => {
    if (!element.rippleContainer) {
      const wrapper = document.createElement('div');
      wrapper.className = RIPPLE_WRAPPER_CLASS;
      element.rippleContainer = wrapper;
      element.appendChild(wrapper);
    }
    return element.rippleContainer;
  };

  const cleanUp = function() {
    const container = this.rippleContainer;
    if (container) {
      while (container.firstChild) {
        container.removeChild(container.firstChild);
      }
    }
  };

  const spawnRipple = (event) => {
    if (event.type === 'pointerdown' && event.button !== 0) {
      return;
    }
    if (event.type === 'pointerdown' && event.pointerType === 'mouse' && event.button !== 0) {
      return;
    }
    const container = event.currentTarget;
    const template = getTemplate(container);
    if (!template) return;

    const rect = container.getBoundingClientRect();
    const rippleContainer = getRippleContainer(container);
    const rippler = document.createElement('span');
    
    const size = Math.max(rect.width, rect.height);
    
    // Check if centered ripple is requested (via data attribute or class)
    const isCentered = container.hasAttribute('data-ripple-center') || 
                       container.classList.contains('ripple-center');
    
    let x, y;
    if (isKeyboardTrigger(event) || isCentered) {
      // Always center for keyboard or when explicitly requested
      x = rect.width / 2 - size / 2;
      y = rect.height / 2 - size / 2;
    } else {
      // Use pageX/pageY for more accurate positioning
      const pageX = event.pageX ?? (event.touches?.[0]?.pageX ?? rect.left + rect.width / 2);
      const pageY = event.pageY ?? (event.touches?.[0]?.pageY ?? rect.top + rect.height / 2);
      x = pageX - rect.left - (size / 2);
      y = pageY - rect.top - (size / 2);
    }

    const style = `top: ${y}px; left: ${x}px; height: ${size}px; width: ${size}px;`;
    rippler.setAttribute('style', style);
    
    rippleContainer.appendChild(rippler);
  };

  const attachRippleHandlers = (container) => {
    if (!container || container.getAttribute(CONTAINER_FLAG) === 'true') return;
    container.classList.add(RIPPLE_CONTAINER_CLASS);
    container.setAttribute(CONTAINER_FLAG, 'true');
    
    // Use mousedown for better compatibility
    container.addEventListener('mousedown', spawnRipple);
    container.addEventListener('pointerdown', spawnRipple);
    container.addEventListener('touchstart', spawnRipple);
    
    // Debounced cleanup on mouseup/touchend
    const debouncedCleanUp = debounce(cleanUp.bind(container), 2000);
    container.addEventListener('mouseup', debouncedCleanUp);
    container.addEventListener('pointerup', debouncedCleanUp);
    container.addEventListener('touchend', debouncedCleanUp);
    
    // Keyboard support
    container.addEventListener('keydown', (event) => {
      if (isKeyboardTrigger(event)) {
        spawnRipple(event);
        const debouncedCleanUp = debounce(cleanUp.bind(container), 2000);
        debouncedCleanUp();
      }
    });
  };

  const createTemplate = (container) => {
    // Create the template span if it doesn't exist
    const template = document.createElement('span');
    template.className = 'touch-ripple';
    template.style.display = 'none';
    container.appendChild(template);
    return template;
  };

  const prepareTemplate = (template) => {
    if (!template || !template.parentElement) return;
    // Check if already prepared by checking if container has handlers attached
    const container = template.parentElement;
    if (container.getAttribute(CONTAINER_FLAG) === 'true') return;
    template.setAttribute(TEMPLATE_FLAG, 'true');
    template.style.display = 'none';
    attachRippleHandlers(container);
  };

  const initRipples = () => {
    // Method 1: Initialize elements with existing touch-ripple spans
    document.querySelectorAll(RIPPLE_TEMPLATE_SELECTOR).forEach(prepareTemplate);
    
    // Method 2: Initialize elements with data-ripple-init attribute
    document.querySelectorAll(`[${RIPPLE_INIT_ATTR}]`).forEach((element) => {
      // Check if template already exists
      let template = element.querySelector(RIPPLE_TEMPLATE_SELECTOR);
      if (!template) {
        // Create template automatically
        template = createTemplate(element);
      }
      prepareTemplate(template);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRipples);
  } else {
    initRipples();
  }

  window.NTRipple = {
    mount: (element) => {
      if (element instanceof HTMLElement) {
        // Check if element has data-ripple-init
        if (element.hasAttribute(RIPPLE_INIT_ATTR)) {
          let template = element.querySelector(RIPPLE_TEMPLATE_SELECTOR);
          if (!template) {
            template = createTemplate(element);
          }
          prepareTemplate(template);
        } else {
          // Check for existing template
          const template = element.querySelector(RIPPLE_TEMPLATE_SELECTOR);
          if (template) {
            prepareTemplate(template);
          }
        }
      }
    },
    refresh: initRipples
  };

  // Auto-initialize ripple effects for dynamically created elements
  // Optimized with debouncing and early filtering to minimize performance impact
  const setupMutationObserver = () => {
    // Check if MutationObserver is supported
    if (typeof MutationObserver === 'undefined') {
      return;
    }

    // Debounce batch processing to handle multiple rapid DOM changes efficiently
    let pendingNodes = new Set();
    let debounceTimer = null;

    const processPendingNodes = () => {
      if (pendingNodes.size === 0) return;

      // Process all pending nodes at once
      pendingNodes.forEach((node) => {
        if (!node || node.nodeType !== Node.ELEMENT_NODE) return;

        // Quick early exit checks (cheap operations)
        const hasRippleInit = node.hasAttribute && node.hasAttribute(RIPPLE_INIT_ATTR);
        const hasTouchRipple = node.classList && node.classList.contains('touch-ripple');
        
        // If node itself needs ripple, process it immediately
        if (hasRippleInit) {
          window.NTRipple.mount(node);
        }
        if (hasTouchRipple && node.parentElement) {
          prepareTemplate(node);
        }

        // Only do expensive querySelector if node might contain ripple elements
        // Skip if node is text, comment, or very small (likely not a container)
        if (node.querySelector && node.children && node.children.length > 0) {
          // Check for nested elements with data-ripple-init
          const rippleInitElements = node.querySelectorAll(`[${RIPPLE_INIT_ATTR}]`);
          rippleInitElements.forEach((el) => {
            if (el !== node) { // Avoid double processing
              window.NTRipple.mount(el);
            }
          });

          // Check for nested touch-ripple spans
          const rippleTemplates = node.querySelectorAll(RIPPLE_TEMPLATE_SELECTOR);
          rippleTemplates.forEach((template) => {
            if (template !== node && template.parentElement) {
              prepareTemplate(template);
            }
          });
        }
      });

      pendingNodes.clear();
    };

    const observer = new MutationObserver((mutations) => {
      // Early exit if no mutations
      if (mutations.length === 0) return;

      // Collect all added nodes
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          // Only process element nodes
          if (node.nodeType === Node.ELEMENT_NODE) {
            pendingNodes.add(node);
          }
        });
      });

      // Debounce processing to batch multiple rapid changes
      if (debounceTimer) {
        clearTimeout(debounceTimer);
      }
      debounceTimer = setTimeout(processPendingNodes, 10); // 10ms debounce
    });

    // Start observing the document body for added nodes
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  };

  // Initialize mutation observer when DOM is ready
  // Can be disabled by setting window.NTRippleAutoInit = false before DOMContentLoaded
  const shouldAutoInit = window.NTRippleAutoInit !== false;
  if (shouldAutoInit) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setupMutationObserver);
    } else {
      setupMutationObserver();
    }
  }

  // Global fix: Clean up ripple effects when Bootstrap modals are hidden
  // This prevents leftover ripple elements from appearing when modals are reopened
  const cleanupModalRipples = () => {
    // Use jQuery if available (Bootstrap modals use jQuery events)
    if (typeof jQuery !== 'undefined') {
      jQuery(document).on('hidden.bs.modal', function(e) {
        const modal = jQuery(e.target);
        // Clean up all ripple elements in the modal
        modal.find('.' + RIPPLE_WRAPPER_CLASS).each(function() {
          while (this.firstChild) {
            this.removeChild(this.firstChild);
          }
        });
      });
    } else {
      // Fallback for vanilla JS (if Bootstrap is used without jQuery)
      document.addEventListener('hidden.bs.modal', function(e) {
        const modal = e.target;
        const rippleContainers = modal.querySelectorAll('.' + RIPPLE_WRAPPER_CLASS);
        rippleContainers.forEach(function(container) {
          while (container.firstChild) {
            container.removeChild(container.firstChild);
          }
        });
      });
    }
  };

  // Initialize modal cleanup when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cleanupModalRipples);
  } else {
    cleanupModalRipples();
  }
})();

/* ------------------
 * - Implementation -
 * ------------------
 * The next block of code implements nuvaApp's
 * functions and plugins as specified by the
 * options above.
 */
$(function () {
  "use strict";

  //Fix for IE page transitions
  $("body").removeClass("hold-transition");

  //Extend options if external options exist
  if (typeof nuvaAppOptions !== "undefined") {
    $.extend(true,
      $.nuvaApp.options,
      nuvaAppOptions);
  }

  //Easy access to options
  var o = $.nuvaApp.options;

  //Set up the object
  _init();

  //Activate the layout maker
  $.nuvaApp.layout.activate();

  //Enable sidebar tree view controls
  if (o.enableControlTreeView) {
    $.nuvaApp.tree('.sidebar');
  }

  //Enable control sidebar
  if (o.enableControlSidebar) {
    $.nuvaApp.controlSidebar.activate();
  }

  //Add slimscroll to navbar dropdown
  if (o.navbarMenuSlimscroll && typeof $.fn.slimscroll != 'undefined') {
    $(".navbar .menu").slimscroll({
      height: o.navbarMenuHeight,
      alwaysVisible: false,
      size: o.navbarMenuSlimscrollWidth
    }).css("width", "100%");
  }

  //Activate sidebar push menu
  if (o.sidebarPushMenu) {
    $.nuvaApp.pushMenu.activate(o.sidebarToggleSelector);
  }

  //Activate Bootstrap tooltip
  /*if (o.enableBSToppltip) {
    $('body').tooltip({
      selector: o.BSTooltipSelector,
      container: 'body'
    });
  }*/

  //Activate box widget
  if (o.enableBoxWidget) {
    $.nuvaApp.boxWidget.activate();
  }

  //Activate fast click
  if (o.enableFastclick && typeof FastClick != 'undefined') {
    FastClick.attach(document.body);
  }

  //Activate direct chat widget
  if (o.directChat.enable) {
    $(document).on('click', o.directChat.contactToggleSelector, function () {
      var box = $(this).parents('.direct-chat').first();
      box.toggleClass('direct-chat-contacts-open');
    });
  }

  /*
   * INITIALIZE BUTTON TOGGLE
   * ------------------------
   */
  $('.btn-group[data-toggle="btn-toggle"]').each(function () {
    var group = $(this);
    $(this).find(".btn").on('click', function (e) {
      group.find(".btn.active").removeClass("active");
      $(this).addClass("active");
      e.preventDefault();
    });

  });
});

/* ----------------------------------
 * - Initialize the nuvaApp Object -
 * ----------------------------------
 * All nuvaApp functions are implemented below.
 */
function _init() {
  'use strict';
  /* Layout
   * ======
   * Fixes the layout height in case min-height fails.
   *
   * @type Object
   * @usage $.nuvaApp.layout.activate()
   *        $.nuvaApp.layout.fix()
   *        $.nuvaApp.layout.fixSidebar()
   */
  $.nuvaApp.layout = {
    activate: function () {
      var _this = this;
      _this.fix();
      _this.fixSidebar();

      $('body, html, .wrapper').css('height', 'auto');

      $(window, ".wrapper").resize(function () {
        _this.fix();
        _this.fixSidebar();
      });
    },
    fix: function () {
      // Remove overflow from .wrapper if layout-boxed exists
      $(".layout-boxed > .wrapper").css('overflow', 'hidden');
      //Get window height and the wrapper height
      var footer_height = $('.main-footer').outerHeight() || 0;
      var neg = $('.main-header').outerHeight() + footer_height;
      var window_height = $(window).height();
      var sidebar_height = $(".sidebar").height() || 0;
      //Set the min-height of the content and sidebar based on the
      //the height of the document.
      if ($("body").hasClass("fixed")) {
        $(".content-wrapper, .right-side").css('min-height', window_height - footer_height);
      } else {
        var postSetWidth;
        if (window_height >= sidebar_height) {
          $(".content-wrapper, .right-side").css('min-height', window_height - neg);
          postSetWidth = window_height - neg;
        } else {
          $(".content-wrapper, .right-side").css('min-height', sidebar_height);
          postSetWidth = sidebar_height;
        }

        //Fix for the control sidebar height
        var controlSidebar = $($.nuvaApp.options.controlSidebarOptions.selector);
        if (typeof controlSidebar !== "undefined") {
          if (controlSidebar.height() > postSetWidth)
            $(".content-wrapper, .right-side").css('min-height', controlSidebar.height());
        }

      }
    },
    fixSidebar: function () {
      //Make sure the body tag has the .fixed class
      if (!$("body").hasClass("fixed")) {
        if (typeof $.fn.slimScroll != 'undefined') {
          $(".sidebar").slimScroll({destroy: true}).height("auto");
        }
        return;
      } else if (typeof $.fn.slimScroll == 'undefined' && window.console) {
        window.console.error("Error: the fixed layout requires the slimscroll plugin!");
      }
      //Enable slimscroll for fixed layout
      if ($.nuvaApp.options.sidebarSlimScroll) {
        if (typeof $.fn.slimScroll != 'undefined') {
          //Destroy if it exists
          $(".sidebar").slimScroll({destroy: true}).height("auto");
          //Add slimscroll
          $(".sidebar").slimScroll({
            height: ($(window).height() - $(".main-header").height()) + "px",
            color: "rgba(0,0,0,0.2)",
            size: "3px"
          });
        }
      }
    }
  };

  /* PushMenu()
   * ==========
   * Adds the push menu functionality to the sidebar.
   *
   * @type Function
   * @usage: $.nuvaApp.pushMenu("[data-toggle='offcanvas']")
   */
  $.nuvaApp.pushMenu = {
    activate: function (toggleBtn) {
      //Get the screen sizes
      var screenSizes = $.nuvaApp.options.screenSizes;

      //Enable sidebar toggle
      $(document).on('click', toggleBtn, function (e) {
        e.preventDefault();

        //Enable sidebar push menu
        if ($(window).width() > (screenSizes.sm - 1)) {
          if ($("body").hasClass('sidebar-collapse')) {
            $("body").removeClass('sidebar-collapse').trigger('expanded.pushMenu');
          } else {
            $("body").addClass('sidebar-collapse').trigger('collapsed.pushMenu');
          }
        }
        //Handle sidebar push menu for small screens
        else {
          if ($("body").hasClass('sidebar-open')) {
            $("body").removeClass('sidebar-open').removeClass('sidebar-collapse').trigger('collapsed.pushMenu');
          } else {
            $("body").addClass('sidebar-open').trigger('expanded.pushMenu');
          }
        }
      });

      $(".content-wrapper").click(function () {
        //Enable hide menu when clicking on the content-wrapper on small screens
        if ($(window).width() <= (screenSizes.sm - 1) && $("body").hasClass("sidebar-open")) {
          $("body").removeClass('sidebar-open');
        }
      });

      //Enable expand on hover for sidebar mini
      if ($.nuvaApp.options.sidebarExpandOnHover
        || ($('body').hasClass('fixed')
        && $('body').hasClass('sidebar-mini'))) {
        this.expandOnHover();
      }
    },
    expandOnHover: function () {
      var _this = this;
      var screenWidth = $.nuvaApp.options.screenSizes.sm - 1;
      //Expand sidebar on hover
      $('.main-sidebar').hover(function () {
        if ($('body').hasClass('sidebar-mini')
          && $("body").hasClass('sidebar-collapse')
          && $(window).width() > screenWidth) {
          _this.expand();
        }
      }, function () {
        if ($('body').hasClass('sidebar-mini')
          && $('body').hasClass('sidebar-expanded-on-hover')
          && $(window).width() > screenWidth) {
          _this.collapse();
        }
      });
    },
    expand: function () {
      $("body").removeClass('sidebar-collapse').addClass('sidebar-expanded-on-hover');
    },
    collapse: function () {
      if ($('body').hasClass('sidebar-expanded-on-hover')) {
        $('body').removeClass('sidebar-expanded-on-hover').addClass('sidebar-collapse');
      }
    }
  };

  /* Tree()
   * ======
   * Converts the sidebar into a multilevel
   * tree view menu.
   *
   * @type Function
   * @Usage: $.nuvaApp.tree('.sidebar')
   */
  $.nuvaApp.tree = function (menu) {
    var _this = this;
    var animationSpeed = $.nuvaApp.options.animationSpeed;
    $(document).off('click', menu + ' li a')
      .on('click', menu + ' li a', function (e) {
        //Get the clicked link and the next element
        var $this = $(this);
        var checkElement = $this.next();

        //Check if the next element is a menu and is visible
        if ((checkElement.is('.treeview-menu')) && (checkElement.is(':visible')) && (!$('body').hasClass('sidebar-collapse'))) {
          //Close the menu
          checkElement.slideUp(animationSpeed, function () {
            checkElement.removeClass('menu-open');
            //Fix the layout in case the sidebar stretches over the height of the window
            //_this.layout.fix();
          });
          checkElement.parent("li").removeClass("hightlight");
        }
        //If the menu is not visible
        else if ((checkElement.is('.treeview-menu')) && (!checkElement.is(':visible'))) {
          //Get the parent menu
          var parent = $this.parents('ul').first();
          //Close all open menus within the parent
          var ul = parent.find('ul:visible').slideUp(animationSpeed);
          //Remove the menu-open class from the parent
          ul.removeClass('menu-open');
          //Get the parent li
          var parent_li = $this.parent("li");

          //Open the target menu and add the menu-open class
          checkElement.slideDown(animationSpeed, function () {
            //Add the class hightlight to the parent li
            checkElement.addClass('menu-open');
            parent.find('li.hightlight').removeClass('hightlight');
            parent_li.addClass('hightlight');
            //Fix the layout in case the sidebar stretches over the height of the window
            _this.layout.fix();
          });
        }
        //if this isn't a link, prevent the page from being redirected
        if (checkElement.is('.treeview-menu')) {
          e.preventDefault();
        }
      });
  };

  /* ControlSidebar
   * ==============
   * Adds functionality to the right sidebar
   *
   * @type Object
   * @usage $.nuvaApp.controlSidebar.activate(options)
   */
  $.nuvaApp.controlSidebar = {
    //instantiate the object
    activate: function () {
      //Get the object
      var _this = this;
      //Update options
      var o = $.nuvaApp.options.controlSidebarOptions;
      //Get the sidebar
      var sidebar = $(o.selector);
      //The toggle button
      var btn = $(o.toggleBtnSelector);

      //Listen to the click event
      btn.on('click', function (e) {
        e.preventDefault();
        //If the sidebar is not open
        if (!sidebar.hasClass('control-sidebar-open')
          && !$('body').hasClass('control-sidebar-open')) {
          //Open the sidebar
          _this.open(sidebar, o.slide);
        } else {
          _this.close(sidebar, o.slide);
        }
      });

      //If the body has a boxed layout, fix the sidebar bg position
      var bg = $(".control-sidebar-bg");
      _this._fix(bg);

      //If the body has a fixed layout, make the control sidebar fixed
      if ($('body').hasClass('fixed')) {
        _this._fixForFixed(sidebar);
      } else {
        //If the content height is less than the sidebar's height, force max height
        if ($('.content-wrapper, .right-side').height() < sidebar.height()) {
          _this._fixForContent(sidebar);
        }
      }
    },
    //Open the control sidebar
    open: function (sidebar, slide) {
      //Slide over content
      if (slide) {
        sidebar.addClass('control-sidebar-open');
      } else {
        //Push the content by adding the open class to the body instead
        //of the sidebar itself
        $('body').addClass('control-sidebar-open');
      }
    },
    //Close the control sidebar
    close: function (sidebar, slide) {
      if (slide) {
        sidebar.removeClass('control-sidebar-open');
      } else {
        $('body').removeClass('control-sidebar-open');
      }
    },
    _fix: function (sidebar) {
      var _this = this;
      if ($("body").hasClass('layout-boxed')) {
        sidebar.css('position', 'absolute');
        sidebar.height($(".wrapper").height());
        if (_this.hasBindedResize) {
          return;
        }
        $(window).resize(function () {
          _this._fix(sidebar);
        });
        _this.hasBindedResize = true;
      } else {
        sidebar.css({
          'position': 'fixed',
          'height': 'auto'
        });
      }
    },
    _fixForFixed: function (sidebar) {
      sidebar.css({
        'position': 'fixed',
        'max-height': '100%',
        'overflow': 'auto',
        'padding-bottom': '50px'
      });
    },
    _fixForContent: function (sidebar) {
      $(".content-wrapper, .right-side").css('min-height', sidebar.height());
    }
  };

  /* BoxWidget
   * =========
   * BoxWidget is a plugin to handle collapsing and
   * removing boxes from the screen.
   *
   * @type Object
   * @usage $.nuvaApp.boxWidget.activate()
   *        Set all your options in the main $.nuvaApp.options object
   */
  $.nuvaApp.boxWidget = {
    selectors: $.nuvaApp.options.boxWidgetOptions.boxWidgetSelectors,
    icons: $.nuvaApp.options.boxWidgetOptions.boxWidgetIcons,
    animationSpeed: $.nuvaApp.options.animationSpeed,
    activate: function (_box) {
      var _this = this;
      if (!_box) {
        _box = document; // activate all boxes per default
      }
      //Listen for collapse event triggers
      $(_box).on('click', _this.selectors.collapse, function (e) {
        e.preventDefault();
        _this.collapse($(this));
      });

      //Listen for remove event triggers
      $(_box).on('click', _this.selectors.remove, function (e) {
        e.preventDefault();
        _this.remove($(this));
      });
    },
    collapse: function (element) {
      var _this = this;
      //Find the box parent
      var box = element.parents(".box").first();
      //Find the body and the footer
      var box_content = box.find("> .box-body, > .box-footer, > form  >.box-body, > form > .box-footer");
      if (!box.hasClass("collapsed-box")) {
        //Convert minus into plus
        element.children(":first")
          .removeClass(_this.icons.collapse)
          .addClass(_this.icons.open);
        //Hide the content
        box_content.slideUp(_this.animationSpeed, function () {
          box.addClass("collapsed-box");
        });
      } else {
        //Convert plus into minus
        element.children(":first")
          .removeClass(_this.icons.open)
          .addClass(_this.icons.collapse);
        //Show the content
        box_content.slideDown(_this.animationSpeed, function () {
          box.removeClass("collapsed-box");
        });
      }
    },
    remove: function (element) {
      //Find the box parent
      var box = element.parents(".box").first();
      box.slideUp(this.animationSpeed);
    }
  };
}

/* ------------------
 * - Custom Plugins -
 * ------------------
 * All custom plugins are defined below.
 */

/*
 * BOX REFRESH BUTTON
 * ------------------
 * This is a custom plugin to use with the component BOX. It allows you to add
 * a refresh button to the box. It converts the box's state to a loading state.
 *
 * @type plugin
 * @usage $("#box-widget").boxRefresh( options );
 */
(function ($) {

  "use strict";

  $.fn.boxRefresh = function (options) {

    // Render options
    var settings = $.extend({
      //Refresh button selector
      trigger: ".refresh-btn",
      //File source to be loaded (e.g: ajax/src.php)
      source: "",
      //Callbacks
      onLoadStart: function (box) {
        return box;
      }, //Right after the button has been clicked
      onLoadDone: function (box) {
        return box;
      } //When the source has been loaded

    }, options);

    //The overlay
    var overlay = $('<div class="overlay"><div class="fa fa-refresh fa-spin"></div></div>');

    return this.each(function () {
      //if a source is specified
      if (settings.source === "") {
        if (window.console) {
          window.console.log("Please specify a source first - boxRefresh()");
        }
        return;
      }
      //the box
      var box = $(this);
      //the button
      var rBtn = box.find(settings.trigger).first();

      //On trigger click
      rBtn.on('click', function (e) {
        e.preventDefault();
        //Add loading overlay
        start(box);

        //Perform ajax call
        box.find(".box-body").load(settings.source, function () {
          done(box);
        });
      });
    });

    function start(box) {
      //Add overlay and loading img
      box.append(overlay);

      settings.onLoadStart.call(box);
    }

    function done(box) {
      //Remove overlay and loading img
      box.find(overlay).remove();

      settings.onLoadDone.call(box);
    }

  };

})(jQuery);

/*
 * EXPLICIT BOX CONTROLS
 * -----------------------
 * This is a custom plugin to use with the component BOX. It allows you to activate
 * a box inserted in the DOM after the app.js was loaded, toggle and remove box.
 *
 * @type plugin
 * @usage $("#box-widget").activateBox();
 * @usage $("#box-widget").toggleBox();
 * @usage $("#box-widget").removeBox();
 */
(function ($) {

  'use strict';

  $.fn.activateBox = function () {
    $.nuvaApp.boxWidget.activate(this);
  };

  $.fn.toggleBox = function () {
    var button = $($.nuvaApp.boxWidget.selectors.collapse, this);
    $.nuvaApp.boxWidget.collapse(button);
  };

  $.fn.removeBox = function () {
    var button = $($.nuvaApp.boxWidget.selectors.remove, this);
    $.nuvaApp.boxWidget.remove(button);
  };

})(jQuery);

/*
 * TODO LIST CUSTOM PLUGIN
 * -----------------------
 * This plugin depends on iCheck plugin for checkbox and radio inputs
 *
 * @type plugin
 * @usage $("#todo-widget").todolist( options );
 */
(function ($) {

  'use strict';

  $.fn.todolist = function (options) {
    // Render options
    var settings = $.extend({
      //When the user checks the input
      onCheck: function (ele) {
        return ele;
      },
      //When the user unchecks the input
      onUncheck: function (ele) {
        return ele;
      }
    }, options);

    return this.each(function () {

      if (typeof $.fn.iCheck != 'undefined') {
        $('input', this).on('ifChecked', function () {
          var ele = $(this).parents("li").first();
          ele.toggleClass("done");
          settings.onCheck.call(ele);
        });

        $('input', this).on('ifUnchecked', function () {
          var ele = $(this).parents("li").first();
          ele.toggleClass("done");
          settings.onUncheck.call(ele);
        });
      } else {
        $('input', this).on('change', function () {
          var ele = $(this).parents("li").first();
          ele.toggleClass("done");
          if ($('input', ele).is(":checked")) {
            settings.onCheck.call(ele);
          } else {
            settings.onUncheck.call(ele);
          }
        });
      }
    });
  };
}(jQuery));


// Initialize OverlayScrollbars
(function ($) {
  'use strict';

  if (typeof $.fn.overlayScrollbars === "function") {
    $('.overlay-scroll').overlayScrollbars({
      // Optional settings
      className: "os-theme-dark", // Theme
    });
  
    $('.overlay-scroll--auto-hide').overlayScrollbars({
      scrollbars: {
        visibility: 'auto', // Hide scrollbars when mouse leaves
        autoHide: 'leave', // Delay before hiding
        autoHideDelay: 100,
      },
      callbacks: {
        onScroll: function() {
          console.log('Scrolling...');
        }
      }
    });
  }
}(jQuery));

(function($) {
  'use strict';
  var screenSizes = $.nuvaApp.options.screenSizes;
  
  if ($(window).width() <= (screenSizes.sm - 1)) {
    if ($("body").hasClass('sidebar-collapse')) {
      $("body").removeClass('sidebar-collapse');
    } else {
      $("body").addClass('sidebar-collapse');
    }
  }
}(jQuery));

/**
 * Updates the state of all fullscreen toggle buttons that control a given target element.
 * This ensures button icons reflect the correct state independently of nested fullscreen elements.
 * 
 * @param {jQuery} $target - The target element that may be fullscreened
 */
function updateFullscreenButtonStates($target) {
  if (!$target || !$target.length) return;
  
  const isFullscreen = $target.hasClass('is-fullscreen');
  
  // Find all buttons with data-fullscreen-toggle that point to this target
  $('[data-fullscreen-toggle]').each(function() {
    const $btn = $(this);
    const btnSelector = $btn.attr('data-fullscreen-toggle');
    if (!btnSelector) return;
    
    let $btnTarget;
    if (btnSelector.startsWith('parent:')) {
      const parentSelector = btnSelector.substring(7); // Remove "parent:" prefix
      $btnTarget = $btn.closest(parentSelector);
    } else {
      $btnTarget = $(btnSelector);
    }
    
    // Check if this button controls the same target element
    if ($btnTarget.length > 0 && $btnTarget[0] === $target[0]) {
      // Update class on button to indicate its target's fullscreen state
      $btn.toggleClass('target-is-fullscreen', isFullscreen);
    }
  });
}

// Global fullscreen toggle handler
// Usage: Add data-fullscreen-toggle="#targetElement" to any button
// The target element will get the 'expanded' class toggled, and body will get 'nt-body-scroll-locked'
// Special case: If selector starts with "parent:", it will find the parent element matching the rest of the selector
// When fullscreened, the element is moved to body level to escape parent stacking contexts
$(document).on('click', '[data-fullscreen-toggle]', function() {
  let targetSelector = $(this).attr('data-fullscreen-toggle');
  if (!targetSelector) return;
  
  let $target;
  
  // Handle special "parent:" prefix to find parent element
  if (targetSelector.startsWith('parent:')) {
    const parentSelector = targetSelector.substring(7); // Remove "parent:" prefix
    $target = $(this).closest(parentSelector);
  } else {
    $target = $(targetSelector);
  }
  
  if ($target.length === 0) return;
  
  const isFullscreen = $target.hasClass('is-fullscreen');
  
  if (isFullscreen) {
    // Exiting fullscreen - restore element to original position
    const originalParent = $target.data('fullscreen-original-parent');
    const originalNextSibling = $target.data('fullscreen-original-next');
    
    if (originalParent) {
      // Restore to original position
      if (originalNextSibling && $(originalNextSibling).length) {
        $target.insertBefore(originalNextSibling);
      } else {
        $(originalParent).append($target);
      }
      $target.removeData('fullscreen-original-parent');
      $target.removeData('fullscreen-original-next');
    }
    
    // Restore any parent fullscreen elements that were hidden
    const hiddenParentFullscreens = $target.data('fullscreen-hidden-parents');
    if (hiddenParentFullscreens && hiddenParentFullscreens.length > 0) {
      hiddenParentFullscreens.forEach(function($parent) {
        if ($parent && $parent.length && $parent.hasClass('is-fullscreen')) {
          // Restore visibility and overflow of parent fullscreen element
          $parent.css('display', '');
          $parent.css('visibility', '');
          $parent.css('overflow', ''); // Restore overflow
        }
      });
      $target.removeData('fullscreen-hidden-parents');
    }
    
    // Restore any other fullscreen elements that were hidden
    const hiddenOthers = $target.data('fullscreen-hidden-others');
    if (hiddenOthers && hiddenOthers.length > 0) {
      hiddenOthers.forEach(function($other) {
        if ($other && $other.length && $other.hasClass('is-fullscreen')) {
          // Restore visibility and overflow
          $other.css('display', '');
          $other.css('overflow', '');
        }
      });
      $target.removeData('fullscreen-hidden-others');
    }
    
    // Remove is-fullscreen class
    $target.removeClass('is-fullscreen');
  } else {
    // Entering fullscreen - move element to body level
    const $originalParent = $target.parent();
    const $nextSibling = $target.next();
    
    // Store original position for restoration
    $target.data('fullscreen-original-parent', $originalParent);
    if ($nextSibling.length) {
      $target.data('fullscreen-original-next', $nextSibling[0]);
    }
    
    // Check if this element is inside any other fullscreened elements
    // If so, hide those parent fullscreen elements to prevent scrollbar duplication
    const hiddenParents = [];
    
    // First, check the parent chain to find any fullscreened ancestors
    let $current = $originalParent;
    while ($current.length && !$current.is('body') && !$current.is('html')) {
      if ($current.hasClass('is-fullscreen')) {
        // Hide this parent fullscreen element to prevent scrollbar duplication
        $current.css('display', 'none');
        $current.css('overflow', 'hidden'); // Also disable overflow to prevent scrollbars
        hiddenParents.push($current);
      }
      $current = $current.parent();
    }
    
    // Also check all other fullscreened elements already in body
    // If this element is inside any of them, hide those too
    $('body > .is-fullscreen').each(function() {
      const $fullscreened = $(this);
      // Skip if this is the target itself
      if ($fullscreened[0] === $target[0]) return;
      
      // Check if target element is inside this fullscreened element
      // by checking if the fullscreened element contains the target
      if ($fullscreened[0].contains($target[0])) {
        // This element is inside the fullscreened element, hide the fullscreened element
        if (hiddenParents.indexOf($fullscreened) === -1) {
          $fullscreened.css('display', 'none');
          $fullscreened.css('overflow', 'hidden'); // Also disable overflow
          hiddenParents.push($fullscreened);
        }
      }
    });
    
    // Store hidden parents for restoration when exiting
    if (hiddenParents.length > 0) {
      $target.data('fullscreen-hidden-parents', hiddenParents);
    }
    
    // Store resizable state before destroying (if it exists)
    // Only check if jQuery UI resizable is available
    if (typeof $.fn.resizable === 'function' && $target.resizable('instance')) {
      $target.data('had-resizable', true);
    }
    
    // Move to body level first
    $('body').append($target);
    
    // Toggle is-fullscreen class on target element (before checking for other fullscreened elements)
    $target.addClass('is-fullscreen');
    
    // Hide all other fullscreened elements in body (except this one)
    // This ensures only one fullscreen element is visible at a time
    const hiddenOthers = [];
    $('body > .is-fullscreen').each(function() {
      const $other = $(this);
      if ($other[0] !== $target[0] && hiddenParents.indexOf($other) === -1) {
        // This is another fullscreened element that we haven't already hidden
        hiddenOthers.push($other);
        $other.css('display', 'none');
        $other.css('overflow', 'hidden');
      }
    });
    
    // Store hidden others for restoration when exiting
    if (hiddenOthers.length > 0) {
      $target.data('fullscreen-hidden-others', hiddenOthers);
    }
  }
  
  // Update all buttons that control this target element
  updateFullscreenButtonStates($target);
  
  // Manage body scroll lock class
  // Add class when entering fullscreen, remove only when no fullscreened elements remain
  if (isFullscreen) {
    // Exiting fullscreen - check if there are any other fullscreened elements
    // Note: We check after removing the class from target, so we need to check all .is-fullscreen elements
    // including hidden ones (since hidden fullscreened elements should still keep scroll lock active)
    const remainingFullscreened = $('body > .is-fullscreen').length;
    if (remainingFullscreened === 0) {
      // No more fullscreened elements, remove scroll lock
      $('body').removeClass('nt-body-scroll-locked');
    }
    // If there are still fullscreened elements (visible or hidden), keep the scroll lock
  } else {
    // Entering fullscreen - always add scroll lock (idempotent, safe to call multiple times)
    $('body').addClass('nt-body-scroll-locked');
  }
  
  // Handle special cases for fullscreen state changes
  // Use setTimeout to ensure DOM manipulation is complete
  setTimeout(function() {
    const isCurrentlyFullscreen = $target.hasClass('is-fullscreen');
    
    if (isCurrentlyFullscreen) {
      // Entering fullscreen
      
      // Close all filter sidebars within the fullscreened element to prevent horizontal scrollbar
      // Don't hide with display:none - just close it so it can still be toggled open in fullscreen
      $target.find('.fm-filter-sidebar').each(function() {
        const $sidebar = $(this);
        // Close the sidebar (translate off-screen)
        $sidebar.css('transform', 'translateX(100%)').data('is-open', false);
        
        // Set sidebar height to match the fullscreen container's scrollHeight
        // This ensures it matches the map container height even when content exceeds 100vh
        const targetId = $target.attr('id') || 'fullscreen-' + Date.now();
        const eventNamespace = 'fullscreen-sidebar-' + targetId;
        
        const updateSidebarHeight = function() {
          // Get the fullscreen container element
          const container = $target[0];
          if (!container) return;
          
          // scrollHeight gives us the total scrollable content height
          // This includes content that extends beyond the visible viewport
          const scrollHeight = container.scrollHeight;
          
          // offsetHeight gives us the visible height (including borders/padding)
          const offsetHeight = container.offsetHeight;
          
          // Use scrollHeight as primary, but ensure it's at least viewport height
          // scrollHeight will be > 100vh when content exceeds viewport
          const containerHeight = Math.max(scrollHeight, window.innerHeight);
          
          // Set the sidebar height to match the scrollable content height
          $sidebar.css('height', containerHeight + 'px');
          
          // Debug log (can be removed in production)
          // console.log('Sidebar height updated:', {
          //   scrollHeight: scrollHeight,
          //   offsetHeight: offsetHeight,
          //   viewportHeight: window.innerHeight,
          //   finalHeight: containerHeight
          // });
        };
        
        // Update height immediately with delays to ensure DOM and images are ready
        setTimeout(updateSidebarHeight, 10);
        setTimeout(updateSidebarHeight, 100);
        setTimeout(updateSidebarHeight, 300);
        setTimeout(updateSidebarHeight, 500);
        
        // Update on window resize
        $(window).on('resize.' + eventNamespace, updateSidebarHeight);
        
        // Update when images inside the container load (map images can change height)
        $target.find('img').on('load.' + eventNamespace, updateSidebarHeight);
        
        // Use MutationObserver to watch for content changes
        const observer = new MutationObserver(function(mutations) {
          // Debounce the update to avoid too many calls
          clearTimeout(observer.updateTimeout);
          observer.updateTimeout = setTimeout(updateSidebarHeight, 50);
        });
        
        // Observe changes to the fullscreen container
        observer.observe($target[0], {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['style', 'class']
        });
        
        // Store the namespace and observer for cleanup
        $sidebar.data('event-namespace', eventNamespace);
        $sidebar.data('mutation-observer', observer);
      });
      
      // Destroy resizable when entering fullscreen (handles will be in wrong position after moving to body)
      // Only check if jQuery UI resizable is available
      if (typeof $.fn.resizable === 'function' && $target.resizable('instance')) {
        $target.resizable('destroy');
      }
    } else {
      // Exiting fullscreen
      
      // Clean up sidebar height update handlers
      $target.find('.fm-filter-sidebar').each(function() {
        const $sidebar = $(this);
        const eventNamespace = $sidebar.data('event-namespace');
        if (eventNamespace) {
          // Remove event handlers using the stored namespace
          $(window).off('resize.' + eventNamespace);
          $target.find('img').off('load.' + eventNamespace);
          $sidebar.removeData('event-namespace');
        }
        
        // Disconnect MutationObserver if it exists
        const observer = $sidebar.data('mutation-observer');
        if (observer) {
          observer.disconnect();
          $sidebar.removeData('mutation-observer');
        }
        
        // Reset height to auto (let CSS handle it)
        $sidebar.css('height', '');
      });
      
      // Re-enable resizable when exiting fullscreen if it was previously enabled
      // Only re-enable if jQuery UI resizable is available
      const hadResizable = $target.data('had-resizable') === true;
      if (hadResizable && typeof $.fn.resizable === 'function') {
        // Re-initialize resizable with aspectRatio (common for map panes)
        $target.resizable({ aspectRatio: true });
        $target.removeData('had-resizable');
      }
    }
  }, 0);
  
  // Trigger custom event for dialog fullscreen buttons to update icon states
  if ($target.hasClass('ui-dialog')) {
    $target.trigger('fullscreen-toggled');
  }
  
  // Trigger custom event for other components to react to fullscreen changes
  // Pass isEnteringFullscreen (true when entering, false when exiting) and the target element
  $target.trigger('fullscreen-state-changed', [isFullscreen ? false : true, $target]);
});

/**
 * Adds a fullscreen toggle button to a jQuery UI dialog.
 * This function should be called in the dialog's 'create' callback.
 * Uses the 'maximized' class approach for jQuery UI dialogs (not 'is-fullscreen').
 * 
 * @param {jQuery} $dialogElement - The jQuery UI dialog element (usually $(this) in create callback)
 * @param {Object} options - Optional configuration object
 * @param {string} options.buttonId - Custom ID for the expand button (optional)
 * @param {string} options.buttonClass - Additional CSS classes for the button (optional)
 * 
 * @example
 * $('#myDialog').dialog({
 *   create: function() {
 *     addDialogFullscreenToggle($(this));
 *   }
 * });
 */
window.addDialogFullscreenToggle = function($dialogElement, options = {}) {
  if (!$dialogElement || !$dialogElement.length) return;
  
  const $dialog = $dialogElement.parent('.ui-dialog');
  if (!$dialog.length) return;
  
  // Check if button already exists
  if ($dialog.find('.ui-dialog-maximize').length > 0) return;
  
  const $close = $dialog.find('.ui-dialog-titlebar-close');
  if (!$close.length) return;
  
  // Create maximize button using ui-dialog-maximize class (matches deviceviewfire.jsp approach)
  const buttonId = options.buttonId || $dialogElement.attr('id') + 'ExpandToggle';
  const buttonClass = 'ui-dialog-maximize' + (options.buttonClass ? ' ' + options.buttonClass : '');
  
  const $max = $('<button>', {
    type: 'button',
    id: buttonId,
    class: buttonClass
  });
  
  // Insert button before close button
  $max.insertBefore($close);
  
  // Add button content with icons (using compress-icon and expand-icon classes)
  $max.html('\
    <span class="touch-ripple"></span>\
    <i class="fa fa-compress js-minimize-icon" title="Minimize"></i>\
    <i class="fa fa-expand js-maximize-icon" title="Maximize"></i>\
  ');
  
  // Handle click to toggle maximized class (not is-fullscreen for dialogs)
  $max.on('click', function() {
    $dialog.toggleClass('maximized');
    $('body').toggleClass('maximize-mode-open');
  });
};
